import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { NextScheduledInpsection } from "../../shared/models/nextScheduledInpsection.model";
import moment from "moment";
import { HtlService } from "../htl.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { HelicoptersService } from "../../helicopters/helicopters.service";
import { LocalStorageService } from "../../shared/local-storage.service";

@Component({
    selector: "app-next-scheduled-inspections-dialog",
    templateUrl: "./next-scheduled-inspections-dialog.component.html",
    styleUrls: ["./next-scheduled-inspections-dialog.component.scss"],
    standalone: false,
})
export class NextScheduledInspectionsDialogComponent implements OnInit {
    public nextInspectionFormGroup: FormGroup;

    private _userSession;

    constructor(
        public dialogRef: MatDialogRef<NextScheduledInspectionsDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        private _data: {
            helicopterId: number;
        },
        private _formBuilder: FormBuilder,
        private _htlService: HtlService,
        private _snackBar: MatSnackBar,
        private _translate: TranslateService,
        private _helicoptersService: HelicoptersService,
        private _localStorageService: LocalStorageService,
    ) {
        this._userSession = this._localStorageService.getUserLocalStorageObject();
        this.nextInspectionFormGroup = this._formBuilder.group({
            id: [""],
            firstCalendarType: ["", [Validators.required]],
            firstCalendarNextDue: ["", [Validators.required]],
            firstLimitHourlyType: ["", [Validators.required]],
            firstLimitHourlyNextDue: ["", [Validators.required, Validators.pattern(/^\d+:[0-5][0-9]$/)]],
            helicopterId: [this._data.helicopterId],
        });
    }

    ngOnInit(): void {
        this._helicoptersService.getHelicopters(this._userSession.organizationId).subscribe((res) => {
            const helicopter = res.filter((h) => h.id === this._data.helicopterId)[0];
            if (helicopter) {
                this.nextInspectionFormGroup.controls["firstCalendarType"].setValue(helicopter.firstCalendarType);
                this.nextInspectionFormGroup.controls["firstCalendarNextDue"].setValue(helicopter.firstCalendarNextDue);
                this.nextInspectionFormGroup.controls["firstLimitHourlyType"].setValue(helicopter.firstLimitHourlyType);
                this.nextInspectionFormGroup.controls["firstLimitHourlyNextDue"].setValue(helicopter.firstLimitHourlyNextDue);
            }
        });
    }

    onFormSubmit() {
        if (this.nextInspectionFormGroup.valid) {
            const object = this.nextInspectionFormGroup.value as NextScheduledInpsection;
            object.firstCalendarNextDue = moment(object.firstCalendarNextDue).format("YYYY-MM-DD");
            this._htlService.updateNextScheduledInspections(object).subscribe((result) => {
                this.dialogRef.close(this.nextInspectionFormGroup.getRawValue());
                this._snackBar.open(this._translate.instant("GENERAL.savedSuccessMsg"), this._translate.instant("GENERAL.close"), {
                    duration: 3000,
                });
            });
        }
    }
}
